// extracted by mini-css-extract-plugin
export default {"description":"sidebar_description__egy5A"};